module.exports = __webpack_public_path__ + "media/npc_dota_hero_silencer.e28e46dc.webm";